import { SmallIcon, Tag, TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { LOCATION_TYPES } from 'modules/attendance/store/models/Shift'
import { resolveShiftLocationType } from 'modules/attendance/lib/locationType'

interface Props {
  hasLocationIssueAndGeofencing: boolean
  outOfRadiusIssue: boolean
  locationType: string | null | undefined
  workplaceName: string | undefined
  hasGeolocation: boolean
  hasGeofencing: boolean
  hasLocationType: boolean
  hasWorkplace: boolean
  hasShiftLocations: boolean
}

export const shiftLocationTagAttributes = ({
  hasLocationIssueAndGeofencing,
  outOfRadiusIssue,
  locationType,
  workplaceName,
  hasGeolocation,
  hasGeofencing,
  hasLocationType,
  hasWorkplace,
  hasShiftLocations,
}: Props): {
  textLabel: string
  tagColor: TagColor
  icon: SmallIcon
} => {
  const { champagne, grey } = Tag.Types
  const { BUSINESS_TRIP, OFFICE, WORK_FROM_HOME } = LOCATION_TYPES

  const tagColor = grey
  const icon: SmallIcon = 'pin'

  const labelForLocationType = (type: string | null | undefined, wpName?: string): string => {
    switch (type) {
      case WORK_FROM_HOME:
        return i18n.t('clock_in.locations.tags.home')
      case OFFICE:
        return wpName ?? i18n.t('clock_in.locations.tags.office')
      case BUSINESS_TRIP:
        return i18n.t('clock_in.locations.tags.business_trip')
      default:
        return i18n.t('clock_in.locations.tooltip.view_location_button')
    }
  }

  const iconForLocationType = (type: string | null | undefined): SmallIcon => {
    switch (type) {
      case WORK_FROM_HOME:
        return 'home'
      case OFFICE:
        return 'office'
      case BUSINESS_TRIP:
        return 'briefcase'
      default:
        return 'pin'
    }
  }

  // 1) Alerts first
  if (hasLocationIssueAndGeofencing) {
    return {
      tagColor: champagne,
      icon: 'alert-circle',
      textLabel: outOfRadiusIssue
        ? i18n.t('clock_in.locations.tooltip.title_out_radius')
        : i18n.t('clock_in.locations.tooltip.title_unknown_radius'),
    }
  }

  // 2) Render explicit location types (including non-office) when selected
  const resolvedLocationType = resolveShiftLocationType(locationType, hasWorkplace)
  if (hasLocationType && resolvedLocationType) {
    return {
      tagColor,
      icon: iconForLocationType(resolvedLocationType),
      textLabel: labelForLocationType(resolvedLocationType, workplaceName),
    }
  }

  // 3) Within radius only when there is no selected location
  if (hasGeofencing && hasShiftLocations) {
    return {
      tagColor,
      icon,
      textLabel: i18n.t('time_tracking.table.body.within_radius'),
    }
  }

  // 4) Geolocation fallback (View location button)
  if (hasGeolocation && hasShiftLocations) {
    return {
      icon,
      tagColor,
      textLabel: i18n.t('clock_in.locations.tooltip.view_location_button'),
    }
  }

  return { tagColor, icon, textLabel: '' }
}
